import { LOCAL_STORAGE_SESSION } from "@/config";

export function getLocalUser() {
  const item = window.localStorage.getItem(LOCAL_STORAGE_SESSION);
  if (!item) return null;
  return JSON.parse(item);
}

export function deleteLocalUser() {
  const item = window.localStorage.getItem(LOCAL_STORAGE_SESSION);
  if (item) window.localStorage.removeItem(LOCAL_STORAGE_SESSION);
}

export function saveLocalUser(data: any) {
  window.localStorage.setItem(LOCAL_STORAGE_SESSION, JSON.stringify(data));
  return getLocalUser();
}
